import { SVGProps } from 'react';
const SidebarMenuIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            viewBox="0 0 16 16"
        >
            <path
                fillRule="evenodd"
                d="M12 1h-1v14h1a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3ZM4 1h6v14H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3Zm0-1a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4Zm3.84 8.748.502-.382-.488-.402-3.445-2.832-.635.773 2.957 2.43-3.003 2.285.605.796L7.84 8.748Z"
                clipRule="evenodd"
            />
        </svg>
    );
};
export default SidebarMenuIcon;
